/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Delivery_DeliveredInputs */

const vi_dashboard_manager_delivery_delivered = /** @type {(inputs: Dashboard_Manager_Delivery_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao`)
};

/**

* @param {Dashboard_Manager_Delivery_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_delivery_delivered = /** @type {((inputs?: Dashboard_Manager_Delivery_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Delivery_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_delivery_delivered(inputs)
});